const GENERIC_ACTIVITY_LABEL = "Activity";
const FERNIE_TOOL_PREFIX = /^fernie-(?:pwa-)?/;

const isFernieTool = (toolName: string): boolean => /^fernie-/.test(toolName);

const stripFerniePrefix = (toolName: string): string => toolName.replace(FERNIE_TOOL_PREFIX, "");

const titleCaseWords = (value: string): string =>
	value
		.split(/[-_]/)
		.filter(Boolean)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");

const humanizeToolName = (toolName: string): string => {
	if (!isFernieTool(toolName)) return GENERIC_ACTIVITY_LABEL;
	return titleCaseWords(stripFerniePrefix(toolName)) || GENERIC_ACTIVITY_LABEL;
};

export default humanizeToolName;
